import React, {Suspense,lazy} from "react"
import ChatWidget from "./components/core/ChatWidget"
import { Icon } from 'antd'

import {SV_SOJ_SVNAV_BRIDGE} from './constants'
import Tacossv from "./views/Tacossv"
import Cartsv from "./views/Cartssv"
import Bussv from "./views/Bussv"
import {  Route, Link } from "react-router-dom"
/*svdec1y25*/
import OverviewContainer from './components/graphs/overviewContainer'

/*svmon24*/
import TacosContainerPage from './views/TacosContainerPage'
import StoredcardsWithCustprofilePage from './views/StoredcardsWithCustprofilePage'
import ReguserContainerComPage from './views/ReguserContainerComPage'
import About from './views/About'
import SVMyResHome from './components/accountsabode/accountcontainer/svmyreshome'
import {ProfilecosmosContainerCom,SVFlySearchCom,SVFlyReviewTerrainCom,SVESSearchCom,RegusersCom,AddressesWithCustprofile,AddressContainerCom,ReguserContainerCom,StoredcardContainerCom,StoredcardsWithCustprofile, LoginabodeContainerCom} from './containers'
import BoatPage from "./views/BoatPage";
import CarPage from './views/CarPage'
import CardOnePage from './views/CardOnePage'
import AddressesWithCustprofilePage from './views/AddressesWithCustprofilePage'
import AddressContainerComPage from './views/AddressContainerComPage'
import StoredcardContainerComPage from './views/StoredcardContainerComPage'
import SpacesWithCustprofilePage from './views/SpacesWithCustprofilePage'
import ReserveWithSearchPage from './views/ReserveWithSearchPage'
import SVTPOrderComPage from './views/SVTPOrderComPage'
import SVTpOrderdetComPage from './views/SVTpOrderdetComPage'
import SVESOrderComPage from './views/SVESOrderComPage'
import SVOrderdetComPage from './views/SVOrderdetComPage'

import FlyReviewWithSearchPage from './views/FlyReviewWithSearchPage'
import FlyReserveWithSearchPage from './views/FlyReserveWithSearchPage'
import FlyWithCustprofilePage from './views/FlyWithCustprofilePage'
import CruiseWithCustprofilePage from './views/CruiseWithCustprofilePage'
import SJReviewTerrainComPage from './views/SJReviewTerrainComPage'
import CRReviewTerrainComPage from './views/CRReviewTerrainComPage'




/*sjaug1 start*/
import SJPBReviewTerrainComPage from './views/SJPBReviewTerrainComPage'
/*sjaug1 end*/

import ShyReserveWithSearchPage from './views/ShyReserveWithSearchPage'
import SVReviewTerrainComPage from './views/SVReviewTerrainComPage'
import SVESSearchComPage from './views/SVESSearchComPage'
import SOJINVSearchComPage from './views/SOJINVSearchComPage'
import SJPBSearchComPage from './views/SJPBSearchComPage'
import SJInvTerrainComPage from './views/SJInvTerrainComPage'
import SJCliTerrainComPage from './views/SJCliTerrainComPage'
/*svjul17 start */
import SJCliFareTerrainComPage from './views/SJCliFareTerrainComPage'
/*svjul17 end */
//import LoginabodeContainerComPage from './views/LoginabodeContainerComPage'
import LogincosmosContainerComPage from "./views/LogincosmosContainerComPage"
import SVProfileComPage from "./views/SVProfileComPage" 

import SVFlySearchComPage from './views/SVFlySearchComPage'
import SVFlyReviewTerrainComPage from './views/SVFlyReviewTerrainComPage'
/*svdec15 */
import SVRCLISearchComPage from './views/SVRCLISearchComPage'
/*svdec2 */
import SVVisSearchComPage from './views/SVVisSearchComPage'
/*svnov18 start*/
import CityTerrainContainer from './components/graphs/sojcontainer/CityTerrain'
import GreatTerrainContainer from './components/graphs/sojcontainer/GreatTerrain'
/*svnov18 end*/
//import  {SVNav} from './components/nav/SVNav'
import { SVHeader } from "./components/nav/SVHeader"
/*svmon24 end*/
import UserHeaderPage from './views/UserHeaderPage'
// Some folks find value in a centralized route config.
// A route config is just data. React is great at mapping
// data into components, and <Route> is a component.

////////////////////////////////////////////////////////////
import './css/svr_footer.css'
const LazySVProfileComPage = lazy(() =>
  import('./views/SVProfileComPage')   
  
);
// first our route components

function Sandwiches() {
  return <h2>Sandwiches</h2>;
}
function SVICOHeaderPageDebug(){
  return <h3>InetSweet COSMOS  Header PAGE - TA will come here Page</h3>;
}
function SVICOHeaderPage(){
  return <h3>Register and Get Discounts -Membership</h3>;
}
/*svdec15*/
function SVVCLHeaderPage(){
  return <h3>Register and Get Cruises -Membership</h3>;
}
/*svdec2 */
function SVVCOHeaderPage(){
  return <h3>Register and Get Analytics -Membership</h3>;
}

function SVINAHeaderPageDebug(){
  return <h3>InetSweet Abode  Header PAGE - TA will come here Page</h3>;
}
function SVINAHeaderPage(){
  return <h3>Register and Get Discounts -Membership</h3>;
}

function SVMFRHeaderPage(){
  return <h3>MyFlyReservatinons Header PAGE - TA will come here Page</h3>;

}
function Users({ routes }) {
  return (
    <div>
      <h2>Users</h2>
      <ul>
        <li>
          <Link to="/myaccountSV/busmyaccount">busmyaccount</Link>
        </li>
        <li>
          <Link to="/myaccountSV/cartmyaccount">cartmyaccount</Link>
        </li>
      </ul>

      {routes.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route} />
      ))}
    </div>
  );
}

function Fleets(ob) {
  console.log(ob)
  const {routes} = ob
  return (
    <div>
     
      
     

      {routes.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route} />
      ))}
    </div>
  );
}

function COSMOSFnSVDebug({routes}){
  return (
    <div>
      <h2>COSMOS Home</h2>
      <ul>
        <li>
          <Link to="/inetcosmos/svredfly/10000972@4@F@10@10@20251124@7@Y@SVR">Sojornreview</Link>
        </li>
        <li>
          <Link to="/inetcosmos/svflysearch">COSMOS</Link>
        </li>
      </ul>

      {routes.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route} />
      ))}
    </div>
  )
}

function COSMOSFnSV({routes}){
  return (
    <div>
      {/*  
      <h2>COSMOS ( SVFlights ) - Home</h2>
      */}

      {routes.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route} />
      ))}
    </div>
  )
}
/*svdec15 start*/
function CRUISESFnSV({routes}){
  return (
    <div>
      {/*  
      <h2>ANALYTICS ( SVFlights ) - Home</h2>
      */}

      {routes.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route} />
      ))}
    </div>
  )
}
/*svdec2 start*/
function ANALYTICSFnSV({routes}){
  return (
    <div>
      {/*  
      <h2>ANALYTICS ( SVFlights ) - Home</h2>
      */}

      {routes.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route} />
      ))}
    </div>
  )
}
/*svdec2 end*/
function SojournsFnSV({ routes }) {
  return (
    <div>
    
      {routes.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route} />
      ))}
    </div>
  );
}
/*svmay3 start*/
function SOJINVFnSV({ routes }) {
  return (
    <div>
    
      {routes.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route} />
      ))}
    </div>
  );
}
/*svmay3 end*/
/*svaug3 start*/
function SJPBFnSV({ routes }) {
  return (
    <div>
    
      {routes.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route} />
      ))}
    </div>
  );
}
/*svaug3 end*/
/*
function SojournsFnSV_bak({ routes }) {
  return (
    <div>
      <h2>Sojourns Home</h2>
      <ul>
        <li>
          <Link to="/inetabode/svredbook/10000972@4@F@10@10@20251124@7@Y@SVR">Sojornreview</Link>
        </li>
        <li>
          <Link to="/inetabode/svessearch">Sojorun</Link>
        </li>
      </ul>

      {routes.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route} />
      ))}
    </div>
  );
}
*/
function Tacos({ routes }) {
  return (
    <div>
      <h2>Tacos</h2>
      <ul>
        <li>
          <Link to="/tacos/bus">BusLink</Link>
        </li>
        <li>
          <Link to="/tacos/cart">CartLink</Link>
        </li>
      </ul>

      {routes.map((route, i) => (
        <RouteWithSubRoutes key={i} {...route} />
      ))}
    </div>
  );
}
function Busmyaccount() {
  return <h3>Busmyaccount</h3>;
}

function Cartmyaccount() {
  return <h3>Cartmyaccount</h3>;
}
function TacosListPage(){
  return <h3>Tacos List Page</h3>;

}
function Bus() {
  return <h3>Bus</h3>;
}

function Cart() {
  return <h3>Cart</h3>;
}

////////////////////////////////////////////////////////////
// then our route config

const svflysearchSV = [
  {
      path: "/inetcosmos",
      component: SVICOHeaderPage,
      routes: [
       
        {
          path: "/inetcosmos/svflysearch",
          component: SVFlySearchComPage
        },
        {
          path: "/inetcosmos/svredfly/:id",
          component: SVFlyReviewTerrainComPage
        }

        
        
      ]
  }
]
/*svdec15 start*/
const svclisearchSV = [
  {
      path: "/inetcruises",
      component: SVVCLHeaderPage,
      routes: [
       
        {
          path: "/inetcruises/svclisearch",
          component: SVRCLISearchComPage
        },
        {
          path: "/inetcruises/crredbook/:id",
          component: CRReviewTerrainComPage
        },
        {
          path: "/inetcruises/svredsr/:id",
          component: SJCliFareTerrainComPage
        },
        {
          path: "/inetcruises/svredcruise/:id",
          component: SJCliTerrainComPage
        }
        

        
        
      ]
  }
]
/*svdec2 start */
const svvissearchSV = [
  {
      path: "/inetanalytics",
      component: SVVCOHeaderPage,
      routes: [
       
        {
          path: "/inetanalytics/svvissearch",
          component: SVVisSearchComPage
        }
        

        
        
      ]
  }
]

/*svdec2 end */
const svessearchSV = [
  {
      path: "/inetabode",
      component: SVINAHeaderPage,
      routes: [
       
        {
          path: "/inetabode/svessearch",
          component: SVESSearchCom
        },
        {
          path: "/inetabode/svredbook/:id",
          component: SVReviewTerrainComPage
        }

        
        
      ]
  }
]


const myflyreservationsSV = [
  {
      path: "/myflyreservationsSV",
      component: SVMFRHeaderPage,
      routes: [
       
        
        {
          path: "/myflyreservationsSV/:id/flyressvCustNew",
          component: FlyReviewWithSearchPage
        }
        
      ]
  }
]

const svflysearch = [
  {
      path: "/svflysearch",
      component: SVFlySearchCom,
      routes: [
        {
          path: "/svflysearch/svredfly/:id",
          component: SVFlyReviewTerrainCom
        }
      ]
  }
]

//svflysearch
//mysvspaceSearch
const svfleets = [
  {
      path: "/myaccountSV/:id",
      component: Fleets,
      //LoginabodeContainerCom
      routes: [
        {
          path: "/myaccountSV/:id/svprofile",
          component: LazySVProfileComPage
      },
        {
          path: "/myaccountSV/:id/svcustomer",
          component: ReguserContainerCom
      },
      //mysvspaceSearch
      {
        path: "/myaccountSV/:id/mysvspaceSearch",
        component: SpacesWithCustprofilePage
    },
    {
          
      path: "/myaccountSV/:id/svspacedet/:orderId",
      component: SVOrderdetComPage
    },
     ///myaccountSV/:id/mysvspacelist
    {
          
      path: "/myaccountSV/:id/mysvspacelist",
      component: SVESOrderComPage
    },
    
    ///myaccountSV/:id/reservesvCustNew/:spaceKey
    {
      path: "/myaccountSV/:id/reservesvCustNew/:spaceKey",
      component: ReserveWithSearchPage
  },

      {
        path: "/myaccountSV/:id/mysvflyspaceSearch",
        component: FlyWithCustprofilePage
    },
    {
      path: "/myaccountSV/:id/myclicruiseSearch",
      component: CruiseWithCustprofilePage
  },
  
    {
          
      path: "/myaccountSV/:id/svflighttripslist",
      component: SVTPOrderComPage
    },
    {
          
      path: "/myaccountSV/:id/svdet/:orderId",
      component: SVTpOrderdetComPage
    },
    /*svmay26 start*/
    {
          
      path: "/myaccountSV/:id/shyressvCustNew/:spaceKey",
      component: ShyReserveWithSearchPage
    },
    /*svmay26 end*/
    {
          
      path: "/myaccountSV/:id/flyressvCustNew/:spaceKey",
      component: FlyReserveWithSearchPage
    },
              {
                  path: "/myaccountSV/:id/myaddressList",
                  component: AddressesWithCustprofilePage
              },
              {
                path: "/myaccountSV/:id/svaddress/:addressId",
                component: AddressContainerComPage
            },
            {
              path: "/myaccountSV/:id/mystoredcardList",
              component: StoredcardsWithCustprofilePage
          },
          {
            path: "/myaccountSV/:id/svstoredcard/:cardId",
            component: StoredcardContainerComPage
        },
       
              {
                  path: "/myaccountSV/:id/cardone/:cardId",
                  component: CardOnePage
              },
              {
                  path: "/myaccountSV/:id/car",
                  component: CarPage
              }
      ]
    }

];

const routes = [
  {
    path: "/sandwiches",
    component: Sandwiches
  },
  {
    path: "/svaoverview",
    component: OverviewContainer
  },
  {
    path: "/about",
    component: About
  },
  
 /* 
 {
    path: "/svessearch",
    component: SVESSearchCom
  },
 {
    path: "/svflysearch",
    component: SVFlySearchCom
    LoginabodeContainerComPage
  },
  {
    path: "/svlogin",
    component: LoginabodeContainerComPage
  },
   {
    path: "/svlogin",
    component: LoginabodeContainerCom
  },
   
  */
  {
    path: "/svlogin",
    component: LogincosmosContainerComPage
  },
  {
    path: "/svhome",
    component: SVMyResHome
  },
  {
    path: "/inetanalytics",
    component: ANALYTICSFnSV,
    routes: [
      {
        path: "/inetanalytics/svvissearch",
        component: SVVisSearchComPage
      }

    ]
},
{
  path: "/inetcruises",
  component: CRUISESFnSV,
  routes: [
    {
      path: "/inetcruises/svclisearch",
      component: SVRCLISearchComPage
    },
    {
      path: "/inetcruises/crredbook/:id",
      component: CRReviewTerrainComPage
    },
    {
      path: "/inetcruises/svredsr/:id",
      component: SJCliFareTerrainComPage
    },
    {
      path: "/inetcruises/svredcruise/:id",
      component: SJCliTerrainComPage
    }
    
  ]
},
  {
    path: "/inetcosmos",
    component: COSMOSFnSV,
    routes: [
     
      {
        path: "/inetcosmos/svflysearch",
        component: SVFlySearchComPage
      },
      {
        path: "/inetcosmos/svredfly/:id",
        component: SVFlyReviewTerrainComPage
      }

      
      
    ]
},
  {
    path: "/inetabode",
    component: SojournsFnSV,
    routes: [ 
      {
        path: "/inetabode/svessearch",
        component: SVESSearchComPage
      },
      {
        path: "/inetabode/svredbook/:id",
        component: SVReviewTerrainComPage
      }
    ]
  },
  {
    path: "/inetsojourn",
    component: SOJINVFnSV,
    routes: [ 
      {
        path: "/inetsojourn/svsojourn",
        component: SOJINVSearchComPage
      },
      /*
      {
        path: "/inetsojourn/svsojourn",
        component: SOJINVSearchComPage
      }
      // <Route path="svredsojourn/:id" component={SVSojournTerrainCom} />    

      ,
      
      */
      {
        path: "/inetsojourn/svredsojourn/:id",
        component: SJInvTerrainComPage
      }
      ,
      {
        path: "/inetsojourn/shredbook/:id",
        component: SJReviewTerrainComPage
      },
      {
        path: "/inetsojourn/pbwilbook/:id",
        component: SJPBReviewTerrainComPage
      }
       /*,
      {
        change this to /inetsojourn/sojredbook/:id and created component TODO 
        path: "/inetabode/svredbook/:id",
        component: SVReviewTerrainComPage
      }
      */
    ]
  },
  /*sjaug3 start*/
  {
    path: "/isjpb",
    component: SJPBFnSV,
    routes: [ 
      {
        path: "/isjpb/probate",
        component:SJPBSearchComPage
      },
      {
        path: "/isjpb/pbwilbook/:id",
        component: SJPBReviewTerrainComPage
      }
       
    ]
  },
  {
    path: "/tacos",
    component: Tacos,
    routes: [
      {
        path: "/tacos/list",
        component: TacosListPage
      },
      {
        path: "/tacos/:id",
        component: TacosContainerPage
      },
      
      {
        path: "/tacos/bus",
        component: Bus
      }
    ]
  },
  {
    path: "/svregus",
    component: Users,
    routes: [
      {
        path: "/svregus/list",
        component: RegusersCom
      },
      {
        path: "/svregus/:id",
        component: ReguserContainerComPage
      },
      {
        path: "/svregus/svstoredcardList",
        component: StoredcardsWithCustprofilePage
      },
      {
        path: "/svregus/busmyaccount",
        component: Busmyaccount
      },
      {
        path: "/svregus/cartmyaccount",
        component: Cartmyaccount
      }
      
      
    ]
  }
];
/*svapr28start*/


const routesUatdemo = [
  
  {
    path: "/about",
    component: About
  },
  
 
  {
    path: "/svlogin",
    component: LogincosmosContainerComPage
  },
  {
    path: "/svhome",
    component: SVMyResHome
  },
  {
    path: "/inetanalytics",
    component: ANALYTICSFnSV,
    routes: [
      {
        path: "/inetanalytics/svvissearch",
        component: SVVisSearchComPage
      }

    ]
  },
  {
    path: "/inetcruises",
    component: CRUISESFnSV,
    routes: [
      {
        path: "/inetcruises/svclisearch",
        component: SVRCLISearchComPage
      },
      ,
      {
        path: "/inetcruises/crredbook/:id",
        component: CRReviewTerrainComPage
      },
      {
        path: "/inetcruises/svredsr/:id",
        component: SJCliFareTerrainComPage
      },
      {
        path: "/inetcruises/svredcruise/:id",
        component: SJCliTerrainComPage
      }
      
    ]
  },
  {
    path: "/inetcosmos",
    component: COSMOSFnSV,
    routes: [
     
      {
        path: "/inetcosmos/svflysearch",
        component: SVFlySearchComPage
      },
      {
        path: "/inetcosmos/svredfly/:id",
        component: SVFlyReviewTerrainComPage
      }

      
      
    ]
},
{
  path: "/inetsojourn",
  component: SOJINVFnSV,
  routes: [ 
    {
      path: "/inetsojourn/svsojourn",
      component: SOJINVSearchComPage
    },
    {
      path: "/inetsojourn/svredsojourn/:id",
      component: SJInvTerrainComPage
    }
    ,
    {
      path: "/inetsojourn/shredbook/:id",
      component: SJReviewTerrainComPage
    },
    {
      path: "/inetsojourn/pbwilbook/:id",
      component: SJPBReviewTerrainComPage
    }
    
  ]
},
  {
    path: "/inetabode",
    component: SojournsFnSV,
    routes: [ 
      {
        path: "/inetabode/svessearch",
        component: SVESSearchComPage
      },
      {
        path: "/inetabode/svredbook/:id",
        component: SVReviewTerrainComPage
      }
      
    ]
  },
 
  {
    path: "/svregus",
    component: Users,
    routes: [
      {
        path: "/svregus/list",
        component: RegusersCom
      },
      {
        path: "/svregus/:id",
        component: ReguserContainerComPage
      },
      {
        path: "/svregus/svstoredcardList",
        component: StoredcardsWithCustprofilePage
      },
      {
        path: "/svregus/busmyaccount",
        component: Busmyaccount
      },
      {
        path: "/svregus/cartmyaccount",
        component: Cartmyaccount
      }
      
      
    ]
  }
];

/*svapr28end*/
const routesProd = [
  
  {
    path: "/about",
    component: About
  },
  
 
  {
    path: "/svlogin",
    component: LogincosmosContainerComPage
  },
  {
    path: "/svhome",
    component: SVMyResHome
  },
  {
    path: "/inetanalytics",
    component: ANALYTICSFnSV,
    routes: [
      {
        path: "/inetanalytics/svvissearch",
        component: SVVisSearchComPage
      } 
    ]
  },
  {
    path: "/inetcruises",
    component: CRUISESFnSV,
    routes: [
      {
        path: "/inetcruises/svclisearch",
        component: SVRCLISearchComPage
      },
      {
        path: "/inetcruises/crredbook/:id",
        component: CRReviewTerrainComPage
      },
      {
        path: "/inetcruises/svredsr/:id",
        component: SJCliFareTerrainComPage
      },
      {
        path: "/inetcruises/svredcruise/:id",
        component: SJCliTerrainComPage
      }
      
    ]
  },
  {
    path: "/inetcosmos",
    component: COSMOSFnSV,
    routes: [
     
      {
        path: "/inetcosmos/svflysearch",
        component: SVFlySearchComPage
      },
      {
        path: "/inetcosmos/svredfly/:id",
        component: SVFlyReviewTerrainComPage
      }

      
      
    ]
},
  {
    path: "/inetabode",
    component: SojournsFnSV,
    routes: [ 
      {
        path: "/inetabode/svessearch",
        component: SVESSearchComPage
      },
      {
        path: "/inetabode/svredbook/:id",
        component: SVReviewTerrainComPage
      }
    ]
  },
  {
    path: "/inetsojourn",
    component: SOJINVFnSV,
    routes: [ 
      {
        path: "/inetsojourn/svsojourn",
        component: SOJINVSearchComPage
      },
      {
        path: "/inetsojourn/svredsojourn/:id",
        component: SJInvTerrainComPage
      }
      ,
      {
        path: "/inetsojourn/shredbook/:id",
        component: SJReviewTerrainComPage
      },
      {
        path: "/inetsojourn/pbwilbook/:id",
        component: SJPBReviewTerrainComPage
      }  
    ]
  },
  {
    path: "/svregus",
    component: Users,
    routes: [
      {
        path: "/svregus/list",
        component: RegusersCom
      },
      {
        path: "/svregus/:id",
        component: ReguserContainerComPage
      },
      {
        path: "/svregus/svstoredcardList",
        component: StoredcardsWithCustprofilePage
      },
      {
        path: "/svregus/busmyaccount",
        component: Busmyaccount
      },
      {
        path: "/svregus/cartmyaccount",
        component: Cartmyaccount
      }
      
      
    ]
  }
];

// wrap <Route> and use this everywhere instead, then when
// sub routes are added to any route it'll work
function RouteWithSubRoutes(route) {
  return (
    <Route
      path={route.path}
      render={props => (
        // pass the sub-routes down to keep nesting
        <route.component {...props} routes={route.routes} />
      )}
    />
  );
}

export default function RouterAmcossvExample() {
  let svmyroutes = null
  if(SV_SOJ_SVNAV_BRIDGE === 'PROD'){
    svmyroutes = routesProd
  }else if(SV_SOJ_SVNAV_BRIDGE === 'UATDEMO'){
    svmyroutes = routesUatdemo

  }else{
    svmyroutes = routes
  }
  return (

  <div  className="container-fluid portfolio-main-container" role="main">
       {/*  
        <ul>
          <li>
            <Link to="/tacos">Tacos</Link>
          </li>
          <li>
            <Link to="/sandwiches">Sandwiches</Link>
          </li>
          <li>
            <Link to="/myaccountSV/-1">myaccountSV Login SV</Link>
          </li>
        </ul>
      */}
      <SVHeader />

         
      <div className="container-fluid">
        <Suspense fallback={<p>SVLoad ing</p>}>
        
          {/*  <Route path="/" component={SVNav} >   </Route>
          {myflyreservationsSV.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
            
              {svessearchSV.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
          */}
            

              {svmyroutes.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
              {svfleets.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
              {svflysearch.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
              {svvissearchSV.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
               {svclisearchSV.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
              {svflysearchSV.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
              
              
            

          <hr />
          
          <div className="row">
              <div className="col-xs-12">
                
                 <CityTerrainContainer></CityTerrainContainer>
                 
              </div>
          </div>
         
          <div className="row">

              <div className="col-xs-12">
                <footer id="svrfooter">
               
          <div   className="row">
                <div id="svrcopyrights" >
                  <p className="svr-copyright-p">Copyrights © 2026 All Rights Reserved by SV Renaissance, Inc.
                            
                            <br/>
                            <small><strong>Seller of Travel </strong>| California | Florida | Iowa | Washington</small>

                              <div class="copyright-links">
                                          <span class="me-4">
                                                          <a href="https://resources.centrav.com/policies/#1536261190453-906fb533-dc97">Terms of Use</a>
                                                      /
                                                          <a href="https://resources.centrav.com/policies/#1536260511131-5934d9aa-991d">Privacy Policy</a>
                                                  </span>
                                                  <span className="terms-date"> <Icon  style={{ color: 'gb(191, 225, 222)', fontSize:'20px' }} type="calendar" theme="filled" /></span> <span  className="terms-content">02/01/2024</span>
                                                  <span className="terms-date"> <Icon  style={{ color: 'gb(91, 225, 22)',fontSize:'20px' }} type="container" theme="filled" /></span><span  className="terms-content">09:40 PM PST </span>
                              </div>

                            </p>
                </div>
          </div>
                  
                  {/*  
                    <div class="container svr-d">
                      <div class="svr-grow">
                      <p>Copyrights © 2026 All Rights Reserved by SV Renaissance, Inc.</p>
                      <p> Copyright SV Renaissance Inc 
                      <br/>
                      <small><strong>Seller of Travel ID</strong>| California</small>

                        <div class="copyright-links">
                                    <span class="me-4">
                                                    <a href="https://resources.centrav.com/policies/#1536261190453-906fb533-dc97">Terms of Use</a>
                                                /
                                                    <a href="https://resources.centrav.com/policies/#1536260511131-5934d9aa-991d">Privacy Policy</a>
                                            </span>
                                <i class="fa-regular fa-calendar-days me-1"></i>05/01/2026
                               <i class="fa-regular fa-clock ms-3 me-1"></i>08:09 PM CT
                        </div>

                      </p>

                      </div>
                      <div class="svrtrusted">
                      <a href="https://www.iatan.org/Pages/default.aspx" target="_blank" class="partner-logo me-3">
                      <img width="134px" height="59px" src="./css/images/bluegrass.jpg" />
              
                    </a>

                      </div>
                    </div>
                    */}
                     
                      
                    
                                            
                                                            
                                    
                  </footer>
              </div>
          </div>
        </Suspense>
      </div>
      <ChatWidget />
              
       
    </div>
  
  );
}
